<template>
    <div class="content-block">
        <div class="content-fields">
            <div class="header-text">
                <strong>Автомобиль</strong>
            </div>
            <div class="td-line text-content">
                <p class="item-info">Марка:</p>
                <div class="" v-if="!redact">
                    <span 
                        v-if="car.security_info[0].avtocod_identifiers_brand_name" 
                        class="item-info">
                        {{car.security_info[0].avtocod_identifiers_brand_name}} 
                    </span>
                    <span class="item-info" v-else>-</span>
                </div>
                <input class="form-input" v-else type="" name="" v-model="form.brand_name">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Номер:</p>
                <span class="item-info" v-if="!redact">{{car.number}} </span>
                <input class="form-input" v-else type="" name="" v-model="form.number">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Вин:</p> 
                <span class="item-info" v-if="!redact">{{car.vin}}</span>
                <input class="form-input" v-else type="" name="" v-model="form.vin">
            </div>
            <div class="td-line text-content">
                <p class="item-info">IMEI:</p>
                <span class="item-info" v-if="!redact">{{car.imei || '-'}}</span>
                <input class="form-input" v-else type="text" inputmode="numeric" v-model="form.imei">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Собственность:</p>
                <span class="item-info">{{car.ownership_type_name || '-'}}</span>
            </div>
            <div class="td-line text-content">
                <p class="item-info">Телефон:</p> 
                <input class="form-input" v-if="redact" type="" name="" v-model="form.ownerPhone">
                <span class="item-info" v-else>{{car.ownerPhone}}</span>
            </div>
        </div>

        <div class="content-buttons">
            <div class="tms-status">
                <security-status-label v-if="car.security_status" class="status-label" :status="car.security_status"/>
            </div>
            <div class="button-container" v-if="!redact">
                <button class="redact-btn" @click="openClose">Изменить</button>
            </div>
            <div v-else class="button-container">
                <button class="redact-btn" @click="openClose">Отмена</button>
                <button class="redact-btn" @click="saveForm">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { saveExecutorForm } from '@/pages/trip/helpers/saveExecutorForm.mjs'

export default {
  name: 'CardCarExecitor',
  props: ['car'],
  setup(props,{emit}){
    const redact = ref(false)
    const form = ref({
        id:props.car.id,
        number:props.car.number,
        vin:props.car.vin,
        ownerPhone:props.car.ownerPhone,
        imei: props.car.imei || '',
        brand_name:props.car.security_info?.[0]?.avtocod_identifiers_brand_name
    })
    

    const saveForm = async () =>{
      const payload = { ...form.value }
      if (payload.imei != null) {
        payload.imei = String(payload.imei).replace(/\D/g, '') || null
      }
      const saved = await saveExecutorForm(emit, { form: payload, model: 'cars' })
      if (!saved) return
      redact.value = false
    }

    
    const openClose = () =>{
        redact.value = !redact.value
    }

    return{
     openClose,
     redact,
     saveForm,
     form,
    }
  }
};
</script>

<style scoped>

.content-block{
  border: 1px solid #ccc;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

.content-fields{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
}

.content-buttons{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.status-label{
  margin-bottom: 20px;
}

.td-line{
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.text-content{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 15px ;
}

.item-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
}


.form-input{
  padding: 2px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-bottom: 3px;
  width: 160px;
}

.tms-status{
    width: 100%;
}

.button-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.redact-btn {
  padding: 4px;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.header-text{
    padding: 5px;
    margin-top: 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: rgba(204, 204, 204, 0.5);
}

.error-msg{
  text-align: center;
  color: rgba(255,105,116, 1.0);
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 3px;
}
</style>
